__turbopack_context__.v({
  "fade-in": "VehicleDetailsTabs-module-scss-module__qXZ-HW__fade-in",
  "group": "VehicleDetailsTabs-module-scss-module__qXZ-HW__group",
  "heading": "VehicleDetailsTabs-module-scss-module__qXZ-HW__heading",
  "no-transform": "VehicleDetailsTabs-module-scss-module__qXZ-HW__no-transform",
  "rotate": "VehicleDetailsTabs-module-scss-module__qXZ-HW__rotate",
  "section": "VehicleDetailsTabs-module-scss-module__qXZ-HW__section",
});
